export default __webpack_public_path__ + "static/media/loit-logo-dash.a160f212.svg";